import type { RouteDef } from '@/app/routes'
import type { WrittenPage } from '../sections'

/** Where an unsubscribe link lands. Noindex, as its two siblings — see them. */
export const route: RouteDef = {
  id: 'newsletterUnsubscribed',
  path: 'newsletter/unsubscribed',
  priority: 0.1,
  robots: 'noindex',
}

export const newsletterUnsubscribed: WrittenPage = {
  navLabel: 'Unsubscribed',
  title: 'You are unsubscribed',
  description: 'This address has been removed from the newsletter.',
  sections: [
    {
      kind: 'prose',
      align: 'center',
      heading: 'You are unsubscribed',
      // No "are you sure?", no offer to stay, no survey. Somebody who clicked
      // unsubscribe has already decided, and the cheapest way to earn a spam
      // report is to make leaving feel like an argument.
      sub: 'That address will not receive the newsletter again.',
      paragraphs: [
        'Nothing else changes: if we are already talking, that conversation carries on as before.',
        'If you change your mind, the subscribe box is at the bottom of any page.',
      ],
      cta: { label: 'Back to the site', href: '/' },
    },
  ],
}
